import type { Dictionary } from '@placer-ui/types';
import { Preset } from 'ui-components/date-picker/date-types/Preset';
import moment, { Moment } from 'moment';

const isDateVisible = (startDate: Moment, minDateToShow: string) => {
    const dateStartDate = startDate.parseZone().startOf('day');

    const presetStart = moment.parseZone(minDateToShow).startOf('day');

    return dateStartDate.isSameOrAfter(presetStart);
};

export const convertPresetToDateSource = (
    presets: Dictionary<Preset>,
    minDateToShow?: string,
) => {
    return Object.values(presets).reduce<{ key: string; label: string }[]>((acc, preset) => {
        if (minDateToShow) {
            if (isDateVisible(preset.value[0], minDateToShow)) {
                acc.push({
                    key: preset.label,
                    label: preset.label,
                });
            }
        } else {
            acc.push({
                key: preset.label,
                label: preset.label,
            });
        }
        return acc;
    }, []);
};
